import { useContext,useEffect,useState } from "react";
import { useNavigate} from "react-router-dom"; 
import { ThemeContext } from "../context/themeContext";
import { useCart } from "./CartContext";
import "./Cart.css";

function Cart({setToggle,onClose}) {
  const { cart, increaseQuantity, decreaseQuantity, formatPrice } = useCart();
  const navigate = useNavigate();

  const { activeTheme } = useContext(ThemeContext);
    const partA = crypto.randomUUID() + crypto.randomUUID();
  const partB = crypto.randomUUID() + crypto.randomUUID();
  const [animatedSavings, setAnimatedSavings] = useState(0);


  // ✅ Token calculations
  const totalOriginalPrice = cart.reduce(
    (sum, item) => sum + item.originalPrice * item.quantity,
    0
  );
  const totalDiscountedPrice = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const totalSavings = totalOriginalPrice - totalDiscountedPrice;

const handlePlaceOrder = () => {
  setToggle(false);
  onClose();
  if (cart.length === 0) return alert("Your cart is empty.");

  // ✅ Package everything for the Payment Page
  navigate(`/payment/${partA}/${partB}`, { 
    state: { 
      cartItems: cart,
      summary: {
        totalOriginalPrice,    // Calculated sum of all originalPrices
        totalDiscountedPrice,  // Calculated sum of all discountedPrices
        totalSavings,           // The "You Saved" amount
      }
    } 
  });
};

  // ✅ Security Check: Prevent UI flash if tokens are missing

  useEffect(() => {
  let start = 0;
  const end = totalSavings;
  const duration = 300; // animation duration in ms
  const increment = Math.ceil(end / (duration / 16)); // ~60fps

  const timer = setInterval(() => {
    start += increment;
    if (start >= end) {
      setAnimatedSavings(end);
      clearInterval(timer);
    } else {
      setAnimatedSavings(start);
    }
  }, 16);

  return () => clearInterval(timer);
}, [totalSavings]);

  

  return (
    <div
      className={`checkout-page-container ${
        activeTheme === "dark" ? "dark-mode" : ""
      }`}
    >
      <div className="checkout-header">
        <div className="back-section" onClick={() => {
            setToggle(false)
             onClose()
          navigate("/dashboard")
          }}>
          <span className="back-icon">&#8249;</span>
          <span className="back-text">Back</span>
        </div>
        <h2 className="checkout-title">Your Cart</h2>
      </div>

      {cart.length === 0 ? (
        <div className="empty-cart-neon">
          {/* Dark overlay */}
          <div className="ec-overlay" />
          {/* Ambient glow accents */}
          <div className="ec-glow-tl" />
          <div className="ec-glow-br" />

          <div className="empty-cart-message">
          <div className="empty-cart-illustration">
            <img src="/image/cart.png" alt="Empty cart" className="empty-cart-img" />
          </div>

          <div className="empty-cart-text-block">
            <h4 className="empty-cart-heading">Nothing here yet!</h4>
            <p className="empty-cart-sub">Looks like you haven't added anything to your cart. Let's fix that.</p>
            <button
              className="ec-shop-btn"
              onClick={() => {
                setToggle(false);
                onClose();
                navigate(`/product/${partA}/${partB}`);
              }}
            >
              ADD TO CART
            </button>
          </div>
        </div>
        </div>
      ) : (
        <>
          <div className="cart-items-list">
            {cart.map((item) => {
              const imagePath = item.image.startsWith("/") ? item.image : `/${item.image}`;

              return (
                <div key={item.id} className="checkout-item">
                  <div className="item-info">
                    <img
                      src={imagePath}
                      alt={item.name}
                      className="checkout-item-image"
                    />
                    <span className="item-title">{item.name}</span>
                  </div>
                  <div className="item-controls">
                    <span className="item-price">
                      {formatPrice(item.price * item.quantity)}
                    </span>
                    <div className="quantity-control-container-cart">
                      <button
                        className="quantity-button-cart"
                        onClick={() => decreaseQuantity(item.id)}
                      >
                        -
                      </button>
                      <span className="quantity-display-cart">{item.quantity}</span>
                      <button
                        className="quantity-button-cart"
                        onClick={() => increaseQuantity(item.id)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="order-summary-box">
            <h3 className="summary-title-cart">Order Summary</h3>
            {cart.map((item) => (
              <div key={item.id} className="summary-row">
                <span>
                  {item.quantity} × {item.name}
                </span>
                <span>
                  {formatPrice(item.originalPrice * item.quantity)}
                </span>
              </div>
            ))}
            <div className="summary-row you-saved">
              <span>You Saved:</span>
              <span>-{formatPrice(animatedSavings)}</span>
            </div>
            <hr className="summary-divider" />
            <div className="summary-row total-price">
              <span>Total Price:</span>
              <span>{formatPrice(totalDiscountedPrice)}</span>
            </div>

            <div className="checkout-buttons">
              <button
                className="place-order-button"
                onClick={handlePlaceOrder}
              >
                Place Order
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Cart;